module.exports = __webpack_public_path__ + "static/media/whitePancakeIcon.04944f79.svg";